"use strict";

var _classCallCheck = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalldataBlock = void 0;

var ethUtil = require("ethereumjs-util");

var CalldataBlock = /*#__PURE__*/function () {
  function CalldataBlock(name, signature, parentName, headerSizeInBytes, bodySizeInBytes) {
    _classCallCheck(this, CalldataBlock);

    this._name = name;
    this._signature = signature;
    this._parentName = parentName;
    this._offsetInBytes = 0;
    this._headerSizeInBytes = headerSizeInBytes;
    this._bodySizeInBytes = bodySizeInBytes;
  }

  _createClass(CalldataBlock, [{
    key: "_setHeaderSize",
    value: function _setHeaderSize(headerSizeInBytes) {
      this._headerSizeInBytes = headerSizeInBytes;
    }
  }, {
    key: "_setBodySize",
    value: function _setBodySize(bodySizeInBytes) {
      this._bodySizeInBytes = bodySizeInBytes;
    }
  }, {
    key: "_setName",
    value: function _setName(name) {
      this._name = name;
    }
  }, {
    key: "getName",
    value: function getName() {
      return this._name;
    }
  }, {
    key: "getParentName",
    value: function getParentName() {
      return this._parentName;
    }
  }, {
    key: "getSignature",
    value: function getSignature() {
      return this._signature;
    }
  }, {
    key: "getHeaderSizeInBytes",
    value: function getHeaderSizeInBytes() {
      return this._headerSizeInBytes;
    }
  }, {
    key: "getBodySizeInBytes",
    value: function getBodySizeInBytes() {
      return this._bodySizeInBytes;
    }
  }, {
    key: "getSizeInBytes",
    value: function getSizeInBytes() {
      return this.getHeaderSizeInBytes() + this.getBodySizeInBytes();
    }
  }, {
    key: "getOffsetInBytes",
    value: function getOffsetInBytes() {
      return this._offsetInBytes;
    }
  }, {
    key: "setOffset",
    value: function setOffset(offsetInBytes) {
      this._offsetInBytes = offsetInBytes;
    }
  }, {
    key: "computeHash",
    value: function computeHash() {
      var rawData = this.getRawData();
      var hash = ethUtil.keccak256(rawData);
      return hash;
    }
  }]);

  return CalldataBlock;
}();

exports.CalldataBlock = CalldataBlock;